import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import { Loader } from '../../../../../common/components';

const TeamListPage = loadable(() => import('./TeamListPage'), {
  fallback: <Loader />
});

const TeamListPageGraph = loadable(() => import('./TeamListPageGraph'), {
  fallback: <Loader />
});

const TeamRoutes = ({ t, teamEmployeeList, employeeAllowAddScoreTeam }) => {
  return [
    <Route
      key="team_table"
      path="/team/table"
      element={<TeamListPage t={t} teamEmployeeList={teamEmployeeList} employeeAllowAddScoreTeam={employeeAllowAddScoreTeam} />}
    />,
    <Route
      key="team_graph"
      path="/team/graph"
      element={<TeamListPageGraph t={t} teamEmployeeList={teamEmployeeList} employeeAllowAddScoreTeam={employeeAllowAddScoreTeam}/>}
    />
  ];
};

TeamRoutes.propTypes = {
  t: PropTypes.func,
  teamEmployeeList: PropTypes.array
};

export default TeamRoutes;
